import { RootState } from 'lib/core/data/reducer'
import { CartId } from 'lib/types'

export const getShippingMethod = (cartId: CartId) => (state: RootState) => {
  const slice = state.quote.setShippingMethod[cartId ?? ''] ?? {}
  return slice
}
